import { useQuery } from '@tanstack/react-query';
import { api } from '../../libs/axios';
import { MovimentacaoFinanceira } from '../../utils/interfaces';

interface ResponseProps {
  data: Record<string, MovimentacaoFinanceira[]>;
  meta: {
    current_page: number;
    per_page: number;
    total: number;
    last_page: number;
    periodo: {
      inicio: string;
      fim: string;
    };
  };
}

interface Params {
  mes: number;
  ano: number;
  periodo: 'mes' | 'ultimos_7' | 'ultimos_15' | 'ultimos_30';
  page: number;
  perPage: number;
}

async function getMovimentacaoFinanceira(params: Params): Promise<ResponseProps> {
  const response = await api
    .get('movimentacao', {
      params: {
        mes: params.periodo === 'mes' ? params.mes : undefined,
        ano: params.periodo === 'mes' ? params.ano : undefined,
        periodo: params.periodo === 'mes' ? undefined : params.periodo,
        page: params.page,
        per_page: params.perPage,
      },
    })
    .then((res) => res.data);

  return response;
}

export function useMovimentacaoFinanceira(params: Params) {
  return useQuery({
    queryKey: ['movimentacao-financeira', params],
    queryFn: () => getMovimentacaoFinanceira(params),
    staleTime: 1,
    gcTime: 1,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
